import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex flex-col items-center justify-center px-4">
      <h1 className="text-6xl font-bold text-[#33564B] mb-2">404</h1>
      <p className="text-gray-600 mb-6">ページが見つかりません</p>
      <button
        onClick={() => navigate('/')}
        className="px-6 py-3 bg-[#33564B] text-white rounded-lg font-medium hover:bg-[#2a463c]"
      >
        ダッシュボードへ戻る
      </button>
    </div>
  );
};

export default NotFound;
